import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mobile-templates-page',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="mobile-templates-page">
      <h2>Мобильные шаблоны</h2>
      <p>Страница управления мобильными шаблонами</p>
    </div>
  `,
  styles: [`
    .mobile-templates-page {
      padding: 20px;
    }
  `]
})
export class MobileTemplatesPageComponent {}